<template>
  <div>
    <b-card>
      <TransactionsList
          :url="url"
          :fields="fields"
          :body="body"
          :updateData="makeCall"
          :showSearch="false"
          :page="'transactions'"
          :title="$t('transactions')"
          @actionButtonTab="actionButtonTab"
      >
        <template #cell(id)="data">
          <b-link @click="showTransaction(data.item)">
            {{ data.item.id }}
          </b-link>
        </template>
        <template #cell(amount)="data">
          <span v-if="data.item.amount">{{ amountFormat(data.item.amount, data.item.currency.name) }}</span>
          <span v-else>-</span>
        </template>
        <template #cell(currency)="data">
          <span>{{ data.item.currency.name }}</span>
        </template>
        <template #cell(status)="data">
          <span v-if="data.item.cancel_transaction_status">{{ $t("canceled") }}</span>
          <div v-else>
            <span v-if="data.value == 0">{{ $t("pending") }} </span>
            <span v-if="data.value == 1">{{ $t("approved") }}</span>
            <span v-if="data.value == 2">{{ $t("declined") }}</span>
          </div>
          <span class="text-secondary" v-if="data.value == 3">{{
              $t("proof_of_ownership_is_in_progress")
            }}</span>
        </template>
        <template #cell(due_date)="data">
          <span>{{ data.item.due_date || '-' }}</span>
        </template>

        <template #cell(bank_details)="data">
          <template v-if="data.item.type_description == 'Withdraw' || data.item.type_description == 'Deposit'">
            <template v-if="
              data.item.bank_name &&
              data.item.iban"
            >
              <p v-if="data.item.bank_name">{{ data.item.bank_name }},</p>
              <p v-if="data.item.iban">{{ data.item.iban }}</p>
            </template>
            <template v-else>
              <span>-</span>
            </template>
          </template>
          <template v-else>
            <span>-</span>
          </template>
        </template>

        <template #cell(action)="data">
          <b-button
              v-if="(data.item.type_description == 'Deposit' || data.item.type_description == 'Withdraw') && adminType(['super_admin','admin_type_a'])"
              v-b-tooltip.hover
              variant="outline-primary"
              size="sm"
              class="mr-1"
              :title="$t('bank_details')"
              @click="seeBankDetails(data.item)"
          >
            <feather-icon icon="InfoIcon"/>
          </b-button>
        </template>
      </TransactionsList>

      <b-modal
          v-model="bankDetailsModal"
          title="Bank Details"
          ok-title="Save"
          cancel-title="Close"
          @ok="saveData"
      >
        <b-form>
          <b-row class="col-12">
            <b-col md="12">
              <b-form-group
                  id="iban"
                  :label="$t('iban') + ':'"
                  label-for="iban-id"
              >
                <b-form-input
                    id="iban-id"
                    v-model.trim="submitData.iban"
                    required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="col-12">
            <b-col md="12">
              <b-form-group
                  id="bank_name"
                  :label="$t('bank_name') + ':'"
                  label-for="bank_name-id"
              >
                <b-form-input
                    id="bank_name-id"
                    v-model.trim="submitData.bank_name"
                    required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>

    </b-card>
  </div>

</template>
<script>
import TransactionsList from "../../components/Reports/TransactionsList.vue";
import AequitexFeeList from "../../components/Reports/AequitexFeeList.vue";
import {CurrencyAmountFormat} from '@core/utils/CurrencyAmountFormat';
import {BFormInput} from "bootstrap-vue";

export default {
  components: {BFormInput, TransactionsList, AequitexFeeList},
  data() {
    return {
      changedTransactionId: null,
      bankDetailsModal: false,
      tabIndex: 0,
      url: "/transactions/admin",
      button: {
        text: "deposit",
        link: "",
        color: "primary",
      },

      fields: [
        {
          key: "__id",
          label: "T-ID",
        },
        {
          key: "invoice_id",
          label: "I-ID",
        },
        {
          key: "user_id",
          label: "U-ID",
        },
        {
          key: "company_id",
          label: "C-ID",
        },
        {
          key: "user",
          label: "User",
        },
        {
          key: "company_role",
          label: "company_role",
        },
        {
          key: "company_name",
          label: "Company",
        },
        {
          key: "type_description",
          label: "Description",
        },
        {
          key: "currency",
          label: "currency",
        },
        {
          key: "status",
          label: "status",
        },
        { key: "due_date",
          label: "due_date"
        },
        { key: "settlement_date",
          label: "settlement_date"
        },
        {
          key: "amount",
          label: "amount",
        },
        {
          key: "invoice_amount",
          label: "original_invoice_amount",
        },
        {
          key: "payment_reason",
          label: "reference_number_payment_reason",
        },
        {
          key: "bank_details",
          label: "SOURCE OF FUNDS",
        },
        {
          key: "created_at",
          label: "Date",
        },
        {
          key: "action",
          label: "action",
        }
      ],
      table: true,
      deposit: null,
      transactions: [],
      body: {
        company_id: this.$route.params.id,
      },

      submitData: {
        iban: null,
        bank_name: null
      }
    };
  },

  created() {
  },

  props: ['companyData', 'data'],

  methods: {
    saveData() {
      this.$http
          .post(`/transactions/admin/change-bank-details/${this.changedTransactionId}`, this.submitData)
          .then((res) => {
            if (res) {
              console.log(44444);
            }
          });
    },

    seeBankDetails(item) {
      this.bankDetailsModal = true
      this.submitData.iban = item.iban
      this.submitData.bank_name = item.bank_name
      this.changedTransactionId = item.__id
    },

    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },

    storeDeposit() {
      this.getTransactions();
    },
    showTransaction(item) {
      this.deposit = item;
      this.table = false;
    },
    actionButtonTab() {
      this.deposit = null;
      this.table = false;
    },
    makeCall() {
      this.getTransactions();
    },
    showTable() {
      this.table = true;
    },
    getTransactions() {
      this.$http
          .post("/transactions/admin", {action: 'reports'})
          .then((res) => {
            if (res) {
              this.transactions = res.data.value.data;
              this.table = true;
            }
          });
    },
  },
};
</script>
